var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"molecule-image-thumb-slider",attrs:{"id":"owl-custom-dots"}},_vm._l((_vm.thumbImages),function(sliderImage,index){return _c('AtomsCommonSliderAtomImageThumbSlider',{key:index,attrs:{"slider-image":sliderImage,"active-thumb":_vm.activeThumb},on:{"click":_vm.handleThumbChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }